<template>
    <div id="app">    
        <v-app dark>    
            <app-header></app-header>            
            <v-container fluid>

                <v-layout row wrap v-scroll="onScroll">    

                    <router-view id="routerView"></router-view>           
                    <transition name="fade">
                    <v-btn
                        fixed
                        dark
                        fab
                        bottom
                        class="mt-5 darken-2"
                        right
                        color="orange"
                        v-if="offsetTop >=200"
                        v-on:click.native.stop="scrollTop"
                    >
                        <v-icon large>keyboard_arrow_up</v-icon>
                    </v-btn>
                    </transition>
                    
                </v-layout>
                <v-snackbar      
                    v-if="snackbarMessage!=''"
                    :color= "snackbarColor"                        
                    vertical
                    v-model="messagebar"
                >               
                {{ snackbarMessage }}
                <v-btn dark flat @click.native="setMessagebar(false)">Close</v-btn>
            </v-snackbar> 
            </v-container>
        </v-app>
    </div>
</template>

<script>


import header from './components/header/Header.vue'

export default {
    $_veeValidate: {
        validator: 'new'
    },
    components: {
        'app-header': header,               
    },
    data() {
        return {
            offsetTop:0
        }
    },  
    methods: {
        onScroll: function(e) {
            this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
        },
        setMessagebar:function(s){
            this.$store.commit('clearMessages')
            this.$store.commit('setMessagebar', s)
        },
        scrollTop: function() {
            var scrollStep = -window.scrollY / (300 / 15),
            scrollInterval = setInterval(function(){
            if ( window.scrollY != 0 ) {
                window.scrollBy( 0, scrollStep );
            }
            else clearInterval(scrollInterval); 
            },15);
        }
    },
    computed: {
        loading: function() {
            return this.$store.getters.loading
        },
        messagebar: {            
            get () {
                return this.$store.getters.messagebar
            },
            set (value) {
                this.$store.commit('clearMessages')
                this.$store.commit('setMessagebar', value)
             }            
        },
        apiSuccess: function() {
            return this.$store.getters.apisuccess
        },
        apiError: function() {
            return this.$store.getters.apierror            
        },
        snackbarMessage: function() {
            var message=''
            if (this.$validator.errors.any()) {
                message=this.$validator.errors.all()
            } else if (this.apiError.message !=''){
                message=this.apiError.message
            } else {
                message=this.apiSuccess.message
            }
            return message            
        },
        snackbarColor: function() {
            if(this.$validator.errors.any() || this.apiError.message !='') {
                return 'error'
            } else if (this.apiSuccess.message != '') {
                return 'success'
            }
        }
    },    
    
}
</script>


<style lang="stylus">
  @require './stylus/main'
  
</style>
    
   



// WEBPACK FOOTER //
// App.vue?de1dca5c